import { useToast } from '@src/contexts/useToastContext';
import { useSW } from '@src/utils/errorHandling/useSW';
import { useEffect } from 'react';
import { useTranslation } from 'react-i18next';

export function UpdateChecker() {
  const { needRefresh, updateServiceWorker } = useSW();
  const toaster = useToast();
  const { t } = useTranslation('view', { keyPrefix: 'update' });

  useEffect(() => {
    if (!needRefresh) {
      return;
    }
    const toastId = toaster?.add({
      message: t('title'),
      type: 'info',
      actionLabel: t('buttonLabel'),
      actionCallback: updateServiceWorker,
    });

    return () => {
      if (toastId) {
        toaster?.remove(toastId);
      }
    };
  }, [needRefresh, updateServiceWorker, toaster, t]);

  return null;
}
